import Text from "./Text";

const CircularProgressBar = ({ percentage }: { percentage: number; }) => {
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - ((percentage > 100 ? 100 : percentage) / 100) * circumference;

  return (
    <div className="progress-circle">
      <svg className="progress-ring" width="180" height="180">
        <circle
          className="progress-ring__circle"
          stroke="#E1E3E9"
          strokeWidth="25"
          fill="transparent"
          r={radius}
          cx="90"
          cy="90"
          style={{
            strokeDasharray: `0`,
            strokeDashoffset: 100,
          }}
        />

        <circle
          className="progress-ring__circle"
          stroke="#0265F9"
          strokeWidth="25"
          fill="transparent"
          r={radius}
          cx="90"
          cy="90"
          style={{
            strokeDasharray: `${circumference} ${circumference}`,
            strokeDashoffset: isNaN(offset) ? 0 : offset,
          }}
        />
      </svg>
      <div className="progress-value">
        <Text size="2xl" color="800">{percentage}%</Text>
      </div>
    </div>
  );
};

export default CircularProgressBar;
